<template>  
  <div class="integralOrderDetailPage">
    <XR-head titleText="订单详情"></XR-head>
    <div class="order-state" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="state-text">{{orderDetail.StateName}}</p>
    </div>
    <router-link :to="'/usercenter/integralOrderDelivery?orderNo='+orderDetail.OrderNo" class="" v-if="orderDetail.DeliveryTracking && orderDetail.DeliveryTracking[0].WuLiu">
      <div class="delivery" v-if="!loaded">
        <div class="leftIcon">
          <i class="fa fa-delivery"></i>
        </div>
        <div class="delivery-process">
          <div class="text">{{ orderDetail.DeliveryTracking[0].WuLiu.data.length>0?orderDetail.DeliveryTracking[0].WuLiu.data[0].context : orderDetail.DeliveryTracking[0].WuLiu.message}}</div>
        </div>
        <div class="rightIcon">
          <i class="fa fa-angle-right"></i>
        </div>
      </div>
    </router-link>
    
    <!-- <router-link :to="'/usercenter/integralOrderDelivery?orderNo='+orderDetail.OrderNo" class="" v-if="orderDetail.DeliveryTracking"> -->
    <div class="receive-address">    
      <span style="line-height: 40px;font-weight: bold;" v-if="!integralorderdetail.Receiver">请选择收货地址</span>
      <div class="mapIcon">
        <img src="/static/icon/address-location.png" />
      </div>
      <div class="address-info" :style="{width:addressInfoWidth+'px'}" v-if="integralorderdetail.Receiver">         
        <div class="contract">
          <span class="name">{{integralorderdetail.Receiver}}</span>
          <span class="mobile">{{integralorderdetail.Phone}}</span>              
        </div>
        <div class="address-content">
          <span class="text">{{integralorderdetail.Address}}</span>
        </div>
      </div>
    </div>
    <!-- </router-link> -->

    <div class="order-list" v-if="!loaded">
      <div class="order-item">
        <div class="shoptip">
          <img class="shop-logo" :src="orderDetail.ShopLogo" />
          <p class="shop-name">{{orderDetail.ShopName}}</p>
          <p class="state"></p>
        </div>
        <div class="hidden-scorll">
          <div class="suborder-item-list">
            <div class="suborder-item" v-for="orderItem in orderDetail.OrderItems" :key="orderItem.ItemId">              
              <router-link :to="'/integral/productDetail?skuId='+orderItem.SkuId">
                <img :src="orderItem.DetailImage?orderItem.DetailImage:IMGServer_URL+'/images/index-item-default.png'" onerror="this.src=IMGServer_URL+'/images/index-item-default.png'" class="order-img" />
                <div class="product-info" :style="{ width:suborderItemProductNameWidth+'px'}">
                  <p class="product-name">{{orderItem.ProductName}}</p>
                  <p class="attr">数量:{{orderItem.Quantity}} {{orderItem.Attribute}}</p>
                  <p class="price">{{orderItem.Integral}}{{pointInfo.PointName}}</p>
                  <router-link class="item-button" :to="'/usercenter/integralOrderEvaluate?itemId='+orderItem.ItemId+'&skuId='+orderItem.SkuId" v-if="orderItem.State==2 && !orderItem.IsComment">评价</router-link>
                </div>   
              </router-link>           
            </div>
          </div>
        </div>
        <div class="order-detail" v-if="!loaded">
          <div class="order-info">
            <div class="field"><span>订单编号：</span>{{orderDetail.OrderNo}}</div>
            <div class="field"><span>下单时间：</span>{{orderDetail.Time.CreateDateName}}</div>
			<div class="field payOverDate" v-if="orderDetail.State ==1"><span> 超时时间  </span><span class="payOverDateTime">{{payOverDateName}}</span></div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>支付方式：</span>{{pointInfo.PointName}}</div>
            <div class="field"><span>支付时间：</span>{{orderDetail.Time.PayDateName}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>配送方式：</span>{{orderDetail.OrderDelivery.ShippingMethodName}}</div>
            <div class="field"><span>期望配送日期：</span>{{orderDetail.OrderDelivery.ShippingDateName}}</div>
          </div>
          <div style="width:90%;height:1px;margin: 0px 10px;border-top:1px dashed #eee"></div>
          <div class="order-info">
            <div class="field"><span>发票抬头：</span>{{orderDetail.InvoiceHead}}</div>
            <div class="field"><span>订单留言：</span>{{orderDetail.Remark}}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="order-detail" v-if="!loaded">  
      <div class="order-info">
        <div class="field">
          <span class="title">商品总额</span>
          <span class="num">{{orderDetail.OrderMoney.TotalIntegral}}{{pointInfo.PointName}}</span>
        </div>
        <div class="field">
          <span class="title">运费</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.FreightMoney.toFixed(2)}}</span>
        </div>
        <div class="summary">
          <span class="title">实付款:</span>
          <span class="num"><i class="fa fa-rmb"></i>{{orderDetail.OrderMoney.CashMoney.toFixed(2)}}</span>
        </div>
      </div>
    </div>
    <div class="operator" v-if="!loaded && (orderDetail.State == 1 || orderDetail.State==5 || orderDetail.State==6)">
      <div class="button-list">
        <router-link :to="'/integral/orderPay?orderNo='+orderDetail.OrderNo" v-if="orderDetail.State == 1">
          <mu-raised-button label="付款" style="background-color:red;float:right;" class="button-item gobuy" primary></mu-raised-button>
        </router-link>
        <mu-raised-button label="取消订单" @click="orderCancel(orderDetail.OrderNo)" class="orderBtn button-item receive" style="background-color:#7C838B;color:#F2F2F3;float:right;" v-if="orderDetail.State ==1"></mu-raised-button> 
        <!-- <mu-raised-button label="再次购买" primary></mu-raised-button> -->
        <mu-raised-button label="确认收货" class="button-item" @click="orderConfrim" primary v-if="orderDetail.State==5 || orderDetail.State==6"></mu-raised-button>
      </div>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import pointconfig from '../../util/pointconfigCache'
export default {
  data () {
    return {
	  pointInfo: pointconfig.getPointconfig(),
      fullWidth:document.documentElement.clientWidth,
      suborderItemProductNameWidth: (parseInt(document.documentElement.clientWidth)-105),
      loaded:true,
      orderDetail:{},
	  payOverDateName:'',
      integralorderdetail:{},
      siteConfig:{ MobileBgImage : '' }
    }
  },
  mounted(){
    this.getPointInfo()
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getOrderDetail()
  },
  methods: {
    getPointInfo: function() {
      const ths = this;
      this.$post("/Shop/IntegralServer/GetPointSetParam")
      .then(function(res) {
        if (res.IsSuccess) {
		  ths.pointInfo = res.Data;
          pointconfig.addPointconfig(res.Data)
        }
      })
      .catch(function(err) {
        console.log(err);
      });
    },
    getSiteInfo: function () {    
        const ths = this;
        this.$post('/Shop/SiteConfigServer/GetSiteConfig')
            .then(function (res) {
            if(res.IsSuccess){
                ths.siteConfig = res.Data
            }         
        })
        .catch(function (err) {
            console.log(err)
        })    
    },      
    getOrderDetail(){     
      var ths = this;   
      ths.$post(
        "/Shop/IntegralServer/GetIntegralOrderDetail",
        JSON.stringify({orderno: this.$route.query.orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.loaded =false
          ths.orderDetail = res.Data
          ths.integralorderdetail=res.Data.OrderDelivery
          ths.$refs.XRtoast.hide()
		  if(res.Data.State == 1){
            var serverTime = res.Data.Time.ServerTime.replace('T',' ')
            serverTime = serverTime.replace(new RegExp('-','g'),"/")
            var ts = (new Date(serverTime))-(new Date());
            var overDate = res.Data.Time.PayOverDate.replace('T',' ')
            overDate = overDate.replace(new RegExp('-','g'),"/")
            ths.calcPayOverDate(ts,overDate)
          }
        }
      });
    },
    calcPayOverDate(tmpTs, payOverDate){      
      var ths = this
      var interval = setInterval(function(){
        var ts = (new Date(payOverDate)) - (new Date()) - tmpTs; //计算剩余的毫秒数    
        if (ts <= 0) {
            ths.payOverDateName='已超时'
            clearInterval(interval);
            return;
        }
        var hh = parseInt(ts / 1000 / 60 / 60, 10); //计算剩余的小时数  
        var mm = parseInt(ts / 1000 / 60 % 60, 10); //计算剩余的分钟数  
        var ss = parseInt(ts / 1000 % 60, 10); //计算剩余的秒数 

        if(hh<10){
          hh= '0'+hh
        }
        if(mm<10){
          mm= '0'+mm
        }
        if(ss<10){
          ss= '0'+ss
        }

        ths.payOverDateName = hh+'时'+mm+"分"+ss+'秒' 
      },1000)
    },
    orderConfrim(){      
      var ths = this;   
      ths.$post(
        "/Shop/IntegralServer/OrderConfrim",
        JSON.stringify({OrderNos: [this.orderDetail.OrderNo]})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.success(res.Msg, true)
          ths.getOrderDetail()
        }
      });
    },  
    orderCancel(orderNo){      
      var ths = this;   
      ths.$post(
        "/Shop/IntegralServer/orderCancel",
        JSON.stringify({OrderNo: orderNo})
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.$refs.XRtoast.successCallback(res.Msg, function(){
            ths.getOrderDetail(true)
          })
        }
      });
    },
  }
}
</script>

<style>
#app .integralOrderDetailPage{
  background: #eee;
  padding-bottom: 56px;
}
.integralOrderDetailPage .order-state{
  overflow: hidden;
  line-height: 60px;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
  color:white;
  padding-left: 15px;

}

.integralOrderDetailPage .delivery {
  overflow: hidden;
  background: white;
  padding:15px 10px;
  margin-top: 10px;
}
.integralOrderDetailPage .delivery .fa{  
  width: 30px;
  margin-top: 4px;
}
.integralOrderDetailPage .delivery .leftIcon {
  float:left;
}
.integralOrderDetailPage .delivery .rightIcon {
  float:right;
  text-align: center;
  margin-top: -23px;
}
.integralOrderDetailPage .delivery .delivery-process{
  overflow: hidden;
  padding-right: 40px;
}
.integralOrderDetailPage .delivery-process .text{
  font-size: 12px;
  color:#999;
  line-height: 16px;
  height: 32px;
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
}

.integralOrderDetailPage .order-delivery {
  overflow: hidden;
  background: white;
  padding:10px;
  margin-top: 10px;
  border-radius: 10px;
}
.integralOrderDetailPage .order-delivery .fa {
  float:left;
  width: 30px;
  margin-top: 4px;
}
.integralOrderDetailPage .order-delivery .delivery-info{
  overflow: hidden;
}
.integralOrderDetailPage .order-delivery .delivery-info .member-info{
  overflow: hidden;
}
.integralOrderDetailPage .order-delivery .member-info .username{
  float: left;
}
.integralOrderDetailPage .order-delivery .member-info .mobile{
  float: left;
  margin-left: 14px;
}
.integralOrderDetailPage .order-delivery .address{
  font-size: 12px;
  color:#999;
}

.integralOrderDetailPage .order-list{
  overflow: hidden;
}
.integralOrderDetailPage .order-item{
  border-radius: 10px;
  background: white;
  margin: 10px 0 0;
}
.integralOrderDetailPage .shoptip{
  border-radius: 10px;
  overflow: hidden;
  background: white;
  padding:0 10px;
}
.integralOrderDetailPage .shoptip .shop-logo{
  float: left;
  line-height: 48px;
  height: 24px;
  margin: 12px 12px 12px 0;
}
.integralOrderDetailPage .shoptip .shop-name{
  float: left;
  line-height: 48px;
}
.integralOrderDetailPage .shoptip .state{
  float: right;
  line-height: 48px;
}

.integralOrderDetailPage .suborder-item-list{
  overflow: hidden;
  padding-left: 10px;
}
.integralOrderDetailPage .suborder-item{
  width:100%;
  overflow: hidden;
  padding: 20px 0;
}
.integralOrderDetailPage .suborder-item ~ .suborder-item{
  border-top:1px solid #eee;
}
.integralOrderDetailPage .suborder-item .order-img{
  width: 75px;
  height: 75px;
  object-fit: cover;
  float: left;
  border: 1px solid #eee;
  padding: 1px;
  background: white;
}
.integralOrderDetailPage .suborder-item .product-info{
  float: left;
  padding: 1px;
  margin-left: 10px;
  margin-right: 10px;
  word-break: break-all;
  height: 85px;
}
.integralOrderDetailPage .suborder-item .product-info .product-name{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 14px;
  padding-bottom: 10px;
  color:#333;
}
.integralOrderDetailPage .suborder-item .product-info .attr{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 14px;
  font-size: 12px;
  color:#999;
}
.integralOrderDetailPage .suborder-item .product-info .price{
  word-break: break-all;
  overflow:hidden;
  text-overflow:ellipsis;
  white-space:nowrap;
  line-height: 16px;
  font-size: 12px;
  margin-top: 24px;
  float: left;
}
.integralOrderDetailPage .receive-address{
  background: white;
  color:black;
  padding: 20px 25px;
  overflow: hidden;
  margin-top: 12px;
  border-radius: 10px;
}
.integralOrderDetailPage .receive-address .address-info{
  float: left;
  margin-left: 10px;
  width: 85%;
}
.integralOrderDetailPage .receive-address .address-info .name{
  font-size:16px;
  padding-right: 10px;
}
.integralOrderDetailPage .receive-address .address-info .mobile{
  font-size:14px;
  color:#aaa;
}
.integralOrderDetailPage .receive-address .address-info .address-content{
  font-size:12px;
  color:#666;
  line-height: 14px;
  height: 28px;
  margin-top: 5px;
}
.integralOrderDetailPage .receive-address .address-info .address-content .fa{
  width: 20px;
}
.integralOrderDetailPage .receive-address .goIcon{
  width:20px;
  height: 14px;
  margin-top: 29px;
}
.integralOrderDetailPage .mapIcon{
  float: left;
  width: 30px;
  line-height: 40px;
}
.integralOrderDetailPage .mapIcon img{
  width:100%;
  display: block;
  margin-top: 10px;
}
.integralOrderDetailPage .suborder-item .product-info .item-button{
  float: right;
  height: 26px;
  line-height: 26px;
  font-size: 12px;
  margin-top: 6px;
  width: 60px;
  margin: 20px 0 0 0;
  padding:0;
  border: none;
  background: #f9f9f9;
  color:#999;
  border:1px solid #999;
  border-radius: 2px;
  margin-left: 10px;
  text-align: center;
}

.integralOrderDetailPage .order-total{
  overflow: hidden;
}
.integralOrderDetailPage .total-text{
  float: right;  
  font-size: 12px;
  line-height: 48px;
}
.integralOrderDetailPage .total-text span{
  font-size: 14px;
}

.integralOrderDetailPage .order-detail{
  border-radius: 10px;
  margin: 10px 0;
  background: white;
}
.integralOrderDetailPage .order-info {
  padding: 10px 0;
}

.integralOrderDetailPage .order-info .field{
  line-height: 24px;
  font-size: 12px;
  padding-left: 10px;
  padding-right: 10px;
  overflow: hidden;
  color:#999;
}
.integralOrderDetailPage .order-info .field span{
  color:#4D4A49;
}
.integralOrderDetailPage .order-info .field .title{
  float: left;
}
.integralOrderDetailPage .order-info .field .num{
  float: right;
  font-size: 14px;
}
.integralOrderDetailPage .order-info .fa{
  font-size: 12px;
}
.integralOrderDetailPage .order-info .summary{
  line-height: 16px;
  font-size: 16px;
  text-align: right;
  margin: 10px 0 0 10px;
  padding: 15px 10px 5px;
}
.integralOrderDetailPage .order-info .summary .num{
  color:red;
}


.integralOrderDetailPage .order-operator{
  overflow: hidden;
}
.integralOrderDetailPage .order-operator .button-list{
  float: right;
  padding: 10px 10px;
}


.integralOrderDetailPage .operator{  
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  background: #f9f9f9;
}
.integralOrderDetailPage .operator .button-list{
  float: right;
}
.integralOrderDetailPage .operator .button-list .button-item{
  height: 56px;
  background-color: rgb(244, 67, 54);
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/integralOrderdetail.vue